export default "__VITE_ASSET__BbkLaDaC__"